import { Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import { CurrencyItem } from '../../types';

export const currenciesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEmployeesCurrencies: build.query<Response<CurrencyItem>, string>({
      query: (cursor) => ({
        url: `/v1/currencies${cursor}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getCountActiveCurrencies: build.query<Response<CurrencyItem>, void>({
      query: () => ({
        url: `/v1/currencies?active=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getEmployeesBaseCurrency: build.query<
      {
        data: CurrencyItem;
      },
      void
    >({
      query: () => ({
        url: `/v1/currencies/base`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getEmployeesCurrency: build.query<{ data: CurrencyItem }, string>({
      query: (id) => ({
        url: `/v1/currencies/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    toggleEmployeesCurrenciesActive: build.mutation<
      {
        data: CurrencyItem;
      },
      { active: boolean; id: string }
    >({
      query: (data: { active: boolean; id: string }) => ({
        url: `/v1/currencies/${data.id}/active`,
        method: 'PUT',
        body: {
          active: data.active,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    toggleCurrenciesStatus: build.mutation<
      {
        // TODO:
        data: CurrencyItem;
      },
      { active: boolean; ids: string[] }
    >({
      query: (data: { active: boolean; ids: string[] }) => ({
        url: `/v1/currencies/batch-status`,
        method: 'PUT',
        body: {
          active: data.active,
          ids: data.ids,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateCurrency: build.mutation<
      {
        data: CurrencyItem;
      },
      { id: string; body: { decimals: number } }
    >({
      query: (data) => ({
        url: `/v1/currencies/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    toggleBaseCurrency: build.mutation<
      {
        data: CurrencyItem;
      },
      string
    >({
      query: (id) => ({
        url: `/v1/currencies/${id}/base`,
        method: 'PUT',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    toggleDefaultCreation: build.mutation<
      {
        data: CurrencyItem;
      },
      { id: string; body: { shouldCreateBalanceForClients: boolean } }
    >({
      query: (data) => ({
        url: `/v1/currencies/${data.id}/balance-for-clients`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetEmployeesCurrenciesQuery,
  useLazyGetCountActiveCurrenciesQuery,
  useLazyGetEmployeesBaseCurrencyQuery,
  useToggleCurrenciesStatusMutation,
  useLazyGetEmployeesCurrencyQuery,
  useToggleEmployeesCurrenciesActiveMutation,
  useToggleBaseCurrencyMutation,
  useToggleDefaultCreationMutation,
  useUpdateCurrencyMutation,
} = currenciesApi;

export const {
  endpoints: {
    getEmployeesCurrencies,
    getEmployeesBaseCurrency,
    toggleCurrenciesStatus,
    getCountActiveCurrencies,
    getEmployeesCurrency,
    toggleEmployeesCurrenciesActive,
    toggleBaseCurrency,
    toggleDefaultCreation,
    updateCurrency,
  },
} = currenciesApi;
